module.exports = __webpack_public_path__ + "img/PL08025.e6de1382.png";